import { useMemo, useState } from 'react'
import emailjs from 'emailjs-com'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import projects from '../../../Data/projects.json'
import './CvPage.css'

/* ===== Datos reales (reutilizados del portafolio) ===== */

const NAV = [
    { id: 'about', label: 'Sobre mí', icon: 'bx-user' },
    { id: 'resume', label: 'Resume', icon: 'bx-file' },
    { id: 'portfolio', label: 'Portafolio', icon: 'bx-grid-alt' },
    { id: 'services', label: 'Servicios', icon: 'bx-bulb' },
    { id: 'contact', label: 'Contacto', icon: 'bx-envelope' },
]

const WHAT_I_DO = [
    {
        icon: 'bx-bot',
        title: 'IA & Automatización',
        text: 'Chatbots de WhatsApp y agentes de voz con IA que atienden y califican clientes 24/7.',
    },
    {
        icon: 'bx-layout',
        title: 'Producto & Web',
        text: 'Apps web y móviles en producción: de la landing a plataformas SaaS completas.',
    },
    {
        icon: 'bx-data',
        title: 'Backend & Datos',
        text: 'APIs escalables y bases de datos robustas (PostgreSQL, Oracle) listas para crecer.',
    },
    {
        icon: 'bx-git-merge',
        title: 'Integraciones',
        text: 'Conecto tus herramientas: WhatsApp, Twilio, OpenAI, mapas, pagos y nube.',
    },
]

const CLIENTS = [
    { name: 'Alcaldía de Medellín', icon: 'bx-buildings' },
    { name: 'Ministerio de Salud', icon: 'bx-plus-medical' },
    { name: 'Contraloría General de la Nación', icon: 'bx-shield-quarter' },
    { name: 'Consejo Superior de la Judicatura', icon: 'bx-been-here' },
    { name: 'Avianca', icon: 'bx-plane' },
    { name: 'Banco Agrario', icon: 'bx-bank' },
    { name: 'Promigas', icon: 'bx-bolt-circle' },
]

const FACTS = [
    { num: '6+', label: 'Años de experiencia' },
    { num: '200K+', label: 'Usuarios alcanzados' },
    { num: '10+', label: 'Deploys en producción' },
    { num: '20+', label: 'Proyectos entregados' },
]

const EXPERIENCE = [
    {
        period: 'Mar 2026 – Actualidad',
        company: 'Soluciones Apps',
        role: 'Líder técnico',
        desc: 'Liderazgo técnico de equipos en apps móviles y web. Definición de arquitectura, estándares de código, integración de backend y acompañamiento al equipo hasta producción.',
    },
    {
        period: 'Sep 2025 – Mar 2026',
        company: 'Sofka Technologies',
        role: 'Desarrollador de software',
        desc: 'Liderazgo técnico en una billetera digital para un banco de Honduras. React Native multiplataforma, arquitecturas limpias, Redux y despliegue exitoso en App Store y Play Store.',
    },
    {
        period: '2024 – Actualidad',
        company: 'SERI S.A.S.',
        role: 'Fundador',
        desc: 'Fundador y director de SERI S.A.S., empresa de desarrollo de software y consultoría TI. Lidero estrategia, clientes y entrega de soluciones a la medida con IA y automatización.',
    },
    {
        period: 'May 2018 – Sep 2025',
        company: 'HYG Consultores',
        role: 'Practicante → Desarrollador',
        desc: 'Aquí empezó mi carrera a los 17. Sistemas de información empresarial, apps React Native (Android/iOS), plataformas React.js y soluciones geoespaciales con PostGIS y Leaflet.',
    },
]

const EDUCATION = [
    {
        period: '2024 – Actualidad',
        company: 'IA aplicada & Automatización',
        role: 'Formación continua',
        desc: 'Especialización autodidacta en LLMs (OpenAI), RAG, agentes de voz y orquestación de automatizaciones con n8n para negocios reales.',
    },
    {
        period: 'Graduado · 2020 – 2026',
        company: 'Ingeniería de Software',
        role: 'Tecnológico de Antioquia (TdeA)',
        desc: 'Ingeniero de Software graduado del Tecnológico de Antioquia (TdeA): fundamentos de ingeniería, arquitectura de software, estructuras de datos, bases de datos y desarrollo web y móvil.',
    },
    {
        period: 'Graduado · Mar 2019',
        company: 'Técnico en Programación de Software',
        role: 'SENA · Medellín',
        desc: 'Formación técnica en programación de software en el SENA. Título obtenido en Medellín en 2019.',
    },
]

const CODING_SKILLS = [
    { name: 'React / React Native', value: 95 },
    { name: 'Node.js', value: 90 },
    { name: 'JavaScript / TypeScript', value: 95 },
    { name: 'PostgreSQL / Oracle', value: 88 },
    { name: 'Java', value: 72 },
    { name: 'Docker', value: 70 },
]

const INFRA_SKILLS = [
    { name: 'Arquitectura en Azure', value: 85 },
    { name: 'Terraform (IaC)', value: 78 },
    { name: 'Ansible', value: 72 },
]

const AI_SKILLS = [
    { name: 'n8n / Automatizaciones', value: 92 },
    { name: 'LLMs (OpenAI)', value: 90 },
    { name: 'Chatbots WhatsApp', value: 93 },
    { name: 'Agentes de voz (Twilio/ElevenLabs)', value: 80 },
    { name: 'RAG / Knowledge Base', value: 78 },
    { name: 'Prompt Engineering', value: 90 },
]

const KNOWLEDGE = [
    'Scrum', 'Clean Architecture', 'Redux', 'PostGIS', 'Leaflet',
    'Next.js', 'AdonisJS', 'Azure', 'Terraform', 'Ansible', 'Fly.io',
    'REST APIs', 'App Store / Play Store', 'UX/UI',
]

const SERVICES = [
    {
        icon: 'bx-bot',
        title: 'IA & Automatización',
        text: 'Agentes de IA listos para producción que atienden WhatsApp, llaman a tus leads y automatizan procesos completos.',
    },
    {
        icon: 'bx-layout',
        title: 'Producto & Web',
        text: 'Más de 7 años construyendo productos digitales: landings que convierten, apps móviles y plataformas SaaS.',
    },
    {
        icon: 'bx-data',
        title: 'Backend & Datos',
        text: 'Arquitecturas y bases de datos que aguantan el crecimiento: APIs rápidas, datos seguros y sistemas estables.',
    },
    {
        icon: 'bx-git-merge',
        title: 'Integraciones & APIs',
        text: 'Conecto tus sistemas para que la información fluya sola: pagos, mapas, CRMs, WhatsApp y modelos de IA.',
    },
]

const FILTERS = [
    { key: 'all', label: 'Todos' },
    { key: 'ia', label: 'IA' },
    { key: 'web', label: 'Web' },
    { key: 'movil', label: 'Móvil' },
]

export default function CvPage() {
    const [activeSection, setActiveSection] = useState('about')
    const [filter, setFilter] = useState('all')
    const [sending, setSending] = useState(false)

    const filteredProjects = useMemo(
        () => (filter === 'all' ? projects : projects.filter((p) => p.typeProject === filter)),
        [filter],
    )

    // Navegación por tabs: cambia la sección visible y sube el contenido al inicio.
    const openTab = (id) => {
        setActiveSection(id)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const sendMessage = (e) => {
        e.preventDefault()
        setSending(true)
        emailjs
            .sendForm('service_9jjxkge', 'template_enirlk4', e.target, 'ptX2eJJVzkGvb0FfF')
            .then(
                () => {
                    e.target.reset()
                    toast.success('¡Recibí tu mensaje! Te contactaré pronto.', { position: 'top-center' })
                    setSending(false)
                },
                () => {
                    toast.error('Algo salió mal, escríbeme por WhatsApp.', { position: 'top-center' })
                    setSending(false)
                },
            )
    }

    return (
        <div className="cv7">
            <div className="cv7__layout">
                {/* ======== SIDEBAR / TARJETA DE PERFIL ======== */}
                <aside className="cv7__sidebar">
                    <div className="cv7__card">
                        <div className="cv7__avatar">
                            <img src="/assets/img/me.png" alt="Santiago Revuelta" />
                        </div>
                        <h1 className="cv7__name">Santiago Revuelta</h1>
                        <p className="cv7__role">Full Stack · IA & Automatización</p>

                        <ul className="cv7__social">
                            <li>
                                <a
                                    href="https://www.linkedin.com/in/santiago-revuelta-rodriguez-8931a41a6/"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="LinkedIn"
                                >
                                    <i className="bx bxl-linkedin" />
                                </a>
                            </li>
                            <li>
                                <a href="https://github.com/santiagorevuelta" target="_blank" rel="noreferrer" aria-label="GitHub">
                                    <i className="bx bxl-github" />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://wa.me/573187260291?text=%C2%A1Hola%20Santiago%21%20Vi%20tu%20CV%20y%20quiero%20hablar%20de%20un%20proyecto."
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="WhatsApp"
                                >
                                    <i className="bx bxl-whatsapp" />
                                </a>
                            </li>
                        </ul>

                        <ul className="cv7__info">
                            <li>
                                <span>Residencia</span>
                                <strong>Colombia</strong>
                            </li>
                            <li>
                                <span>Email</span>
                                <strong>srevuelta.dev@gmail.com</strong>
                            </li>
                            <li>
                                <span>Empresa</span>
                                <a href="https://www.serisas.com" target="_blank" rel="noreferrer" className="cv7__seri-link">SERI S.A.S. <i className="bx bx-link-external" /></a>
                            </li>
                            <li>
                                <span>Disponibilidad</span>
                                <strong className="cv7__available">Freelance disponible</strong>
                            </li>
                        </ul>

                        <a className="cv7__download" href="/assets/pdf/SantiagoRevuelta.pdf" download>
                            <i className="bx bx-download" /> Descargar CV
                        </a>
                    </div>
                </aside>

                {/* ======== CONTENIDO ======== */}
                <main className="cv7__content">
                    {/* Navegación */}
                    <nav className="cv7__nav">
                        <a href="/" className="cv7__logo">Santi<span>.Rev</span></a>
                        <ul>
                            {NAV.map((item) => (
                                <li key={item.id}>
                                    <button
                                        type="button"
                                        className={activeSection === item.id ? 'is-active' : ''}
                                        onClick={() => openTab(item.id)}
                                    >
                                        <i className={`bx ${item.icon}`} />
                                        <span>{item.label}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* ===== ABOUT ===== */}
                    <section className={`cv7__section ${activeSection === 'about' ? 'is-visible' : ''}`} id="about">
                        <header className="cv7__head">
                            <h2>Sobre mí</h2>
                            <span className="cv7__head-bg">Perfil</span>
                        </header>

                        <p className="cv7__lead">
                            Soy <strong>Santiago Revuelta</strong>, Desarrollador Full Stack con más de 6 años
                            de trayectoria y fundador de <a href="https://www.serisas.com" target="_blank" rel="noreferrer" className="cv7__inline-link"><strong>SERI S.A.S.</strong></a> Construyo soluciones
                            escalables de alto impacto: desde billeteras digitales para banca internacional hasta
                            sistemas de información geográfica. Hoy me especializo en <strong>IA aplicada y
                            automatización</strong>: chatbots de WhatsApp, agentes de voz y flujos con n8n que
                            atienden y hacen crecer negocios 24/7.
                        </p>

                        <h3 className="cv7__subhead">Lo que hago</h3>
                        <div className="cv7__grid cv7__grid--4">
                            {WHAT_I_DO.map((item) => (
                                <article className="cv7__service" key={item.title}>
                                    <i className={`bx ${item.icon}`} />
                                    <h4>{item.title}</h4>
                                    <p>{item.text}</p>
                                </article>
                            ))}
                        </div>

                        <div className="cv7__facts">
                            {FACTS.map((f) => (
                                <div className="cv7__fact" key={f.label}>
                                    <strong>{f.num}</strong>
                                    <span>{f.label}</span>
                                </div>
                            ))}
                        </div>

                        <h3 className="cv7__subhead">Proyectos y clientes con los que he trabajado</h3>
                        <div className="cv7__clients-carousel">
                            <div className="cv7__clients-track">
                                {[...CLIENTS, ...CLIENTS].map((c, i) => (
                                    <div className="cv7__client" key={c.name + i} aria-hidden={i >= CLIENTS.length}>
                                        <i className={`bx ${c.icon}`} />
                                        <span>{c.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* <div className="cv7__seri-banner">
                            <div className="cv7__seri-banner-text">
                                <h3>¿Necesitas software o un chatbot con IA para tu negocio?</h3>
                                <p>Conoce <strong>SERI S.A.S.</strong>, mi empresa de desarrollo de software y
                                   consultoría TI. Ahí viven productos como Anaia, Numa, Tour 360 y RevPOS.</p>
                            </div>
                            <a className="cv7__seri-banner-btn" href="https://www.serisas.com" target="_blank" rel="noreferrer">
                                Visitar SERI <i className="bx bx-right-arrow-alt" />
                            </a>
                        </div> */}
                    </section>

                    {/* ===== RESUME ===== */}
                    <section className={`cv7__section ${activeSection === 'resume' ? 'is-visible' : ''}`} id="resume">
                        <header className="cv7__head">
                            <h2>Resume</h2>
                            <span className="cv7__head-bg">Trayectoria</span>
                        </header>

                        <div className="cv7__grid cv7__grid--2">
                            <div>
                                <h3 className="cv7__subhead"><i className="bx bx-briefcase-alt-2" /> Experiencia</h3>
                                <div className="cv7__timeline">
                                    {EXPERIENCE.map((item) => (
                                        <div className="cv7__tl-item" key={item.company + item.period}>
                                            <span className="cv7__tl-period">{item.period}</span>
                                            <h4>{item.company}</h4>
                                            <span className="cv7__tl-role">{item.role}</span>
                                            <p>{item.desc}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div>
                                <h3 className="cv7__subhead"><i className="bx bx-book" /> Educación</h3>
                                <div className="cv7__timeline">
                                    {EDUCATION.map((item) => (
                                        <div className="cv7__tl-item" key={item.company + item.period}>
                                            <span className="cv7__tl-period">{item.period}</span>
                                            <h4>{item.company}</h4>
                                            <span className="cv7__tl-role">{item.role}</span>
                                            <p>{item.desc}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="cv7__grid cv7__grid--2 cv7__skills">
                            <div>
                                <h3 className="cv7__subhead">IA & Automatización</h3>
                                {AI_SKILLS.map((s) => (
                                    <Bar key={s.name} {...s} />
                                ))}
                            </div>
                            <div>
                                <h3 className="cv7__subhead">Desarrollo</h3>
                                {CODING_SKILLS.map((s) => (
                                    <Bar key={s.name} {...s} />
                                ))}
                                <h3 className="cv7__subhead">Infraestructura & Cloud</h3>
                                {INFRA_SKILLS.map((s) => (
                                    <Bar key={s.name} {...s} />
                                ))}
                            </div>
                        </div>

                        <h3 className="cv7__subhead">Conocimientos</h3>
                        <div className="cv7__tags">
                            {KNOWLEDGE.map((k) => (
                                <span key={k}>{k}</span>
                            ))}
                        </div>
                    </section>

                    {/* ===== PORTFOLIO ===== */}
                    <section className={`cv7__section ${activeSection === 'portfolio' ? 'is-visible' : ''}`} id="portfolio">
                        <header className="cv7__head">
                            <h2>Portafolio</h2>
                            <span className="cv7__head-bg">Proyectos</span>
                        </header>

                        <div className="cv7__filters">
                            {FILTERS.map((f) => (
                                <button
                                    key={f.key}
                                    type="button"
                                    className={filter === f.key ? 'is-active' : ''}
                                    onClick={() => setFilter(f.key)}
                                >
                                    {f.label}
                                </button>
                            ))}
                        </div>

                        <div className="cv7__grid cv7__grid--3">
                            {filteredProjects.map((p) => {
                                const hasLink = p.projectURL && p.projectURL !== '#'
                                const Card = (
                                    <>
                                        <div className="cv7__work-img">
                                            <img src={`/assets/img/${p.img}`} alt={p.title} loading="lazy" />
                                            <span className="cv7__work-type">{p.typeProject}</span>
                                        </div>
                                        <div className="cv7__work-body">
                                            <h4>{p.title}</h4>
                                            <p>{p.description}</p>
                                            {hasLink && (
                                                <span className="cv7__work-link">
                                                    Ver proyecto <i className="bx bx-right-arrow-alt" />
                                                </span>
                                            )}
                                        </div>
                                    </>
                                )
                                return hasLink ? (
                                    <a
                                        className="cv7__work"
                                        key={p.key}
                                        href={p.projectURL}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {Card}
                                    </a>
                                ) : (
                                    <article className="cv7__work" key={p.key}>
                                        {Card}
                                    </article>
                                )
                            })}
                        </div>
                    </section>

                    {/* ===== SERVICES ===== */}
                    <section className={`cv7__section ${activeSection === 'services' ? 'is-visible' : ''}`} id="services">
                        <header className="cv7__head">
                            <h2>Servicios</h2>
                            <span className="cv7__head-bg">Ofrezco</span>
                        </header>

                        <p className="cv7__lead">
                            Soluciones que se pagan solas: menos trabajo manual, más clientes atendidos y
                            sistemas que funcionan mientras duermes.
                        </p>

                        <div className="cv7__grid cv7__grid--2">
                            {SERVICES.map((s) => (
                                <article className="cv7__service cv7__service--row" key={s.title}>
                                    <i className={`bx ${s.icon}`} />
                                    <div>
                                        <h4>{s.title}</h4>
                                        <p>{s.text}</p>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </section>

                    {/* ===== CONTACT ===== */}
                    <section className={`cv7__section ${activeSection === 'contact' ? 'is-visible' : ''}`} id="contact">
                        <header className="cv7__head">
                            <h2>Contacto</h2>
                            <span className="cv7__head-bg">Hablemos</span>
                        </header>

                        <div className="cv7__grid cv7__grid--contact">
                            <ul className="cv7__contact-info">
                                <li>
                                    <i className="bx bx-envelope" />
                                    <div>
                                        <span>Email</span>
                                        <a href="mailto:srevuelta.dev@gmail.com">srevuelta.dev@gmail.com</a>
                                    </div>
                                </li>
                                <li>
                                    <i className="bx bxl-whatsapp" />
                                    <div>
                                        <span>WhatsApp</span>
                                        <a href="https://wa.me/573187260291" target="_blank" rel="noreferrer">+57 318 726 0291</a>
                                    </div>
                                </li>
                                <li>
                                    <i className="bx bx-map" />
                                    <div>
                                        <span>Ubicación</span>
                                        <strong>Colombia · Remoto</strong>
                                    </div>
                                </li>
                                <li>
                                    <i className="bx bx-check-circle" />
                                    <div>
                                        <span>Estado</span>
                                        <strong className="cv7__available">Freelance disponible</strong>
                                    </div>
                                </li>
                            </ul>

                            <form className="cv7__form" onSubmit={sendMessage} autoComplete="off">
                                <div className="cv7__form-row">
                                    <input name="from_name" type="text" placeholder="Tu nombre" required />
                                    <input name="from_email" type="email" placeholder="Tu email" required />
                                </div>
                                <textarea name="from_message_contact" rows="6" placeholder="Cuéntame sobre tu proyecto" required />
                                <button type="submit" className="cv7__submit" disabled={sending}>
                                    {sending ? 'Enviando…' : 'Enviar mensaje'} <i className="bx bx-send" />
                                </button>
                            </form>
                        </div>
                    </section>

                    <footer className="cv7__footer">
                        <p>© {new Date().getFullYear()} Santiago Revuelta</p>
                        <a href="/">Volver al portafolio</a>
                    </footer>
                </main>
            </div>
            <ToastContainer />
        </div>
    )
}

function Bar({ name, value }) {
    return (
        <div className="cv7__bar">
            <div className="cv7__bar-head">
                <span>{name}</span>
                <span>{value}%</span>
            </div>
            <div className="cv7__bar-track">
                <div className="cv7__bar-fill" style={{ width: `${value}%` }} />
            </div>
        </div>
    )
}
